import React from "react";
import {KoerberLabel} from "../Label/Label.style";
import {KoerberCheckbox, KoerberCheckboxFill, KoerberCheckboxWrapper} from "./Checkbox.style";
import sanitizeHtml from "sanitize-html";
import sanitizeWhiteList from "../../sanitize-html.whitelist";

const Checkbox = (props) => {
    const { labelText, checked, name, disabled, required, onChange, className, onClick, value, labelComponent } = props;

    return (
        <KoerberCheckboxWrapper className={"checkbox"} disabled={disabled}>
            <KoerberCheckbox
                type="checkbox"
                name={name}
                onChange={onChange}
                onClick={onClick}
                value={value}
                className={className}
                checked={checked}
                required={required}
                disabled={disabled}
                />
            <KoerberCheckboxFill />
            <KoerberLabel 
                className="p-regular" 
                htmlFor={name}
                required={required}
                disabled={disabled}
                dangerouslySetInnerHTML={{
                __html: sanitizeHtml(labelText, sanitizeWhiteList),
                }} />
        </KoerberCheckboxWrapper>
    )
}

export default Checkbox;